import { annualSolarSavings } from '../solar/selectors';
import { getSRECs } from '../srecs/selectors';
import { getITC, getMACRS } from '../tax/selectors';
import { getSMARTvalue } from '../smart/selectors';

export const getCAPAnnualPayment = (state, year) => {
    const { cashprice } = state.solar;
    const {
        capDownPayment,
        capTerm,
    } = state.cap;

    let paymentFactor = 0;
    if (capTerm === 36) {
        if (cashprice > 19999.99 && cashprice < 100000) {
            paymentFactor = 0.0327383;
        }
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.0320329;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.0315214;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.0311019;
        }
    }
    if (capTerm === 48) {
        if (cashprice > 19999.99 && cashprice < 100000) {
            paymentFactor = 0.0253623;
        }
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.024885;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.0243055;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.02394622;
        }
    }
    if (capTerm === 60) {
        if (cashprice > 19999.99 && cashprice < 100000) {
            paymentFactor = 0.021149;
        }
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.020516;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.0199857;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.019674;
        }
    }
    if (capTerm === 72) {
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.0175332;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.01709704;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.01680994;
        }
    }
    if (capTerm === 84) {
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.0155862;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.0151416;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.01484943;
        }
    }

    const capPrice = cashprice - capDownPayment;

    let capPayment = 0;

    if (year <= capTerm / 12) {
        capPayment = capPrice * paymentFactor * 12;
    }

    return capPayment;
};
export const getCAPAnnualPaymentESS = (state, year) => {
    const { cashprice } = state.solar;
    const {
        capDownPayment,
        capTerm,
    } = state.cap;
    const { includeESS, essPrice } = state.ess;

    let paymentFactor = 0;
    if (capTerm === 36) {
        if (cashprice > 19999.99 && cashprice < 100000) {
            paymentFactor = 0.0327383;
        }
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.0320329;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.0315214;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.0311019;
        }
    }
    if (capTerm === 48) {
        if (cashprice > 19999.99 && cashprice < 100000) {
            paymentFactor = 0.0253623;
        }
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.024885;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.0243055;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.02394622;
        }
    }
    if (capTerm === 60) {
        if (cashprice > 19999.99 && cashprice < 100000) {
            paymentFactor = 0.021149;
        }
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.020516;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.0199857;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.019674;
        }
    }
    if (capTerm === 72) {
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.0175332;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.01709704;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.01680994;
        }
    }
    if (capTerm === 84) {
        if (cashprice >= 100000 && cashprice < 150000) {
            paymentFactor = 0.0155862;
        }
        if (cashprice >= 150000 && cashprice < 300000) {
            paymentFactor = 0.0151416;
        }
        if (cashprice >= 300000) {
            paymentFactor = 0.01484943;
        }
    }

    let capPrice = cashprice - capDownPayment;
    if (includeESS === true) {
        capPrice = cashprice + essPrice - capDownPayment;
    }

    let capPayment = 0;

    if (year <= capTerm / 12) {
        capPayment = capPrice * paymentFactor * 12;
    }

    return capPayment;
};

export const getAnnualCAPIntDeductionValue = (state, year) => {
    // const { capTerm, capDownPayment } = state.cap;
    // const { taxRate } = state.tax;
    // const { cashprice } = state.solar;

    // const totalCapPayments = getCAPAnnualPayment(state, year);

    let cashValueIntDeduction = 0;

    // const term = capTerm / 12;
    const term = 60 / 12;
    // const tax = taxRate / 100;
    // const totInterest = (totalCapPayments * term) - cashprice - capDownPayment;
    // const interestYearly = totInterest / term;

    if (year <= term) {
        // cashValueIntDeduction = interestYearly * tax;
        cashValueIntDeduction = 0;
    }
    return cashValueIntDeduction;
};


export const getAnnualCAPSavings = (state, prevSolarValue, year) => {
    const { capTerm, capDownPayment } = state.cap;

    let capSavings = 0;
    const srecs = getSRECs(state);
    const smart = getSMARTvalue(state);


    if (year === 1) {
        capSavings =
            annualSolarSavings(year, prevSolarValue, state) +
            srecs[year] -
            getCAPAnnualPayment(state, year) +
            getMACRS(state, year) +
            getITC(state) +
            smart[year] +
            getAnnualCAPIntDeductionValue(state, year) -
            capDownPayment;
    } else if (year <= capTerm / 12) {
        capSavings =
            annualSolarSavings(year, prevSolarValue, state)
            + smart[year]
            + srecs[year]
            - getCAPAnnualPayment(state, year)
            + getAnnualCAPIntDeductionValue(state, year);
    } else {
        capSavings =
            annualSolarSavings(year, prevSolarValue, state) +
            srecs[year] +
            smart[year] -
            getCAPAnnualPayment(state, year);
    }
    return capSavings;
};



// WEBPACK FOOTER //
// ./src/containers/common/cap/selectors.js